import { getApiBaseUrl } from "../config/api";

export type JoinResponse = {
  id: string;
  waitlist_name: string;
  waitlist_email: string;
  waitlist_joined_at: string;
};

export const postJoin = (
  name: string,
  email: string,
): Promise<JoinResponse> => {
  return fetch(`${getApiBaseUrl()}/waitlist/join`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, email }),
  }).then((response) => {
    if (!response.ok) throw new Error(String(response.status));
    return response.json();
  });
};
